import React from 'react'
import BreadcrumbItem from './BreadcrumbItem'
import './Breadcrumb.css'

export type CrumbInfo = {
  url: string
  text: string
  enabled: boolean
}

type Props = {
  info: CrumbInfo[]
}

function Breadcrumb(props: Props) {
  const { info } = props
  
  return (
    <span id="breadcrumb">
      {info.map(crumb => (
        <BreadcrumbItem key={crumb.url} item={crumb} />
      ))}
    </span>
  )
}

export default Breadcrumb
